// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern AI-Style Assessment Page */

.assessmentMainDiv {
    min-height: calc(100vh - 80px);
    padding: 40px 60px;
    background: #ffffff;
    position: relative;
    margin-top: 40px;
}

/* Breadcrumb Navigation */
.assessmentBreadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 30px;
    font-size: 14px;
    position: relative;
    z-index: 1;
}

.breadcrumbLink {
    color: #667eea;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
    text-decoration: none;
    padding: 4px 8px;
    border-radius: 6px;
}

.breadcrumbLink:hover {
    color: #764ba2;
    background: rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
}

.breadcrumbCurrent {
    color: #6b7280;
    font-weight: 400;
}

.breadcrumbArrow {
    font-size: 12px !important;
    color: #9ca3af !important;
}

/* Main Container */
.assessmentContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    position: relative;
    z-index: 1;
    max-width: 1400px;
    margin: 0 auto;
}

/* Left Section - Assessment Info */
.assessmentInfoSection {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.assessmentHeader {
    animation: fadeInUp 0.6s ease-out;
}

.assessmentIconWrapper {
    width: 70px;
    height: 70px;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    transition: all 0.3s ease;
}

.assessmentIconWrapper:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
}

.assessmentIcon {
    font-size: 36px !important;
    color: #667eea !important;
}

.assessmentTitle {
    font-size: 42px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 12px 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
}

.assessmentSubtitle {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
    font-weight: 400;
}

/* Assessment Details Card */
.assessmentDetailsCard {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 24px !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
    padding: 0 !important;
    overflow: hidden;
    animation: fadeInUp 0.8s ease-out 0.2s both;
    transition: all 0.3s ease;
}

.assessmentDetailsCard:hover {
    transform: translateY(-5px);
    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2) !important;
}

.assessmentDetailsCard .ant-card-body {
    padding: 32px !important;
}

.assessmentDetailItem {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 20px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.assessmentDetailItem:last-child {
    border-bottom: none;
}

.assessmentDetailItem:hover {
    padding-left: 10px;
}

.detailIconWrapper {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    flex-shrink: 0;
}

.detailIconWrapper.timeIcon {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);
}

.detailIconWrapper.questionIcon {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.detailIcon {
    font-size: 28px !important;
    color: #ffffff !important;
}

.detailContent {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
}

.detailLabel {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.detailValue {
    font-size: 20px;
    color: #1f2937;
    font-weight: 600;
}

.assessmentNote {
    margin-top: 20px;
    padding: 16px 20px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border-radius: 12px;
    border-left: 4px solid #667eea;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.noteIcon {
    color: #667eea !important;
    font-size: 20px !important;
    margin-top: 2px;
    flex-shrink: 0;
}

.assessmentNote p {
    margin: 0;
    color: #4b5563;
    font-size: 14px;
    line-height: 1.6;
}

/* Right Section - Visual & Action */
.assessmentActionSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    position: relative;
    animation: fadeInUp 0.8s ease-out 0.4s both;
}

.assessmentVisualWrapper {
    position: relative;
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.gradientOrb {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.6;
    animation: float 6s ease-in-out infinite;
}

.orb1 {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    top: 10%;
    left: 10%;
    animation-delay: 0s;
}

.orb2 {
    width: 150px;
    height: 150px;
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    bottom: 20%;
    right: 15%;
    animation-delay: 2s;
}

.orb3 {
    width: 180px;
    height: 180px;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: 4s;
}

@keyframes float {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(20px, -20px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
}

.assessmentImageContainer {
    position: relative;
    z-index: 2;
    animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}

.assessmentImage {
    width: 320px;
    height: 320px;
    object-fit: contain;
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2));
    transition: all 0.3s ease;
}

.assessmentImage:hover {
    transform: scale(1.05) rotate(2deg);
    filter: drop-shadow(0 25px 50px rgba(0, 0, 0, 0.3));
}

/* Start Test Button */
.startTestButton {
    width: 100%;
    max-width: 320px;
    height: 60px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    border-radius: 16px !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #ffffff !important;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4) !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 10px !important;
    position: relative;
    overflow: hidden;
}

.startTestButton::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
}

.startTestButton:hover::before {
    left: 100%;
}

.startTestButton:hover {
    transform: translateY(-3px) scale(1.02) !important;
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.5) !important;
}

.startTestButton:active {
    transform: translateY(-1px) scale(0.98) !important;
}

.startTestButton:disabled {
    opacity: 0.7 !important;
    cursor: not-allowed !important;
    transform: none !important;
}

.startTestButton .anticon {
    font-size: 22px !important;
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 1200px) {
    .assessmentContainer {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .assessmentActionSection {
        order: -1;
    }

    .assessmentVisualWrapper {
        height: 300px;
    }

    .assessmentImage {
        width: 250px;
        height: 250px;
    }
}

@media (max-width: 768px) {
    .assessmentMainDiv {
        padding: 30px 20px;
    }

    .assessmentTitle {
        font-size: 32px;
    }

    .assessmentSubtitle {
        font-size: 14px;
    }

    .assessmentDetailsCard .ant-card-body {
        padding: 24px !important;
    }

    .assessmentDetailItem {
        padding: 16px 0;
    }

    .detailIconWrapper {
        width: 48px;
        height: 48px;
    }

    .detailIcon {
        font-size: 24px !important;
    }

    .detailValue {
        font-size: 18px;
    }

    .assessmentVisualWrapper {
        height: 250px;
    }

    .assessmentImage {
        width: 200px;
        height: 200px;
    }

    .startTestButton {
        max-width: 100%;
        height: 56px !important;
        font-size: 16px !important;
    }
}

@media (max-width: 480px) {
    .assessmentMainDiv {
        padding: 20px 16px;
    }

    .assessmentBreadcrumb {
        font-size: 12px;
        flex-wrap: wrap;
    }

    .assessmentTitle {
        font-size: 28px;
    }

    .assessmentIconWrapper {
        width: 60px;
        height: 60px;
    }

    .assessmentIcon {
        font-size: 30px !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/CareerProgram/CareerAssesment/CareerAssesment.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,gDAAgD;IAChD,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,sDAAsD;IACtD,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,4CAA4C;IAC5C,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;IAC7D,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,8FAA8F;IAC9F,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,WAAW,mCAAmC,EAAE;IAChD,MAAM,4CAA4C,EAAE;IACpD,MAAM,4CAA4C,EAAE;AACxD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,WAAW,mBAAmB,EAAE;IAChC,MAAM,sBAAsB,EAAE;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;IACnC,mDAAmD;AACvD;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,wEAAwE;IACxE,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,2DAA2D;IAC3D,oCAAoC;IACpC,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kDAAkD;IAClD,2DAA2D;AAC/D;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* Modern AI-Style Assessment Page */\n\n.assessmentMainDiv {\n    min-height: calc(100vh - 80px);\n    padding: 40px 60px;\n    background: #ffffff;\n    position: relative;\n    margin-top: 40px;\n}\n\n/* Breadcrumb Navigation */\n.assessmentBreadcrumb {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 30px;\n    font-size: 14px;\n    position: relative;\n    z-index: 1;\n}\n\n.breadcrumbLink {\n    color: #667eea;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-weight: 500;\n    text-decoration: none;\n    padding: 4px 8px;\n    border-radius: 6px;\n}\n\n.breadcrumbLink:hover {\n    color: #764ba2;\n    background: rgba(102, 126, 234, 0.1);\n    transform: translateY(-1px);\n}\n\n.breadcrumbCurrent {\n    color: #6b7280;\n    font-weight: 400;\n}\n\n.breadcrumbArrow {\n    font-size: 12px !important;\n    color: #9ca3af !important;\n}\n\n/* Main Container */\n.assessmentContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 40px;\n    position: relative;\n    z-index: 1;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n/* Left Section - Assessment Info */\n.assessmentInfoSection {\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n}\n\n.assessmentHeader {\n    animation: fadeInUp 0.6s ease-out;\n}\n\n.assessmentIconWrapper {\n    width: 70px;\n    height: 70px;\n    background: rgba(102, 126, 234, 0.1);\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n    transition: all 0.3s ease;\n}\n\n.assessmentIconWrapper:hover {\n    transform: translateY(-5px) scale(1.05);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n}\n\n.assessmentIcon {\n    font-size: 36px !important;\n    color: #667eea !important;\n}\n\n.assessmentTitle {\n    font-size: 42px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 12px 0;\n    line-height: 1.2;\n    letter-spacing: -0.5px;\n}\n\n.assessmentSubtitle {\n    font-size: 16px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.6;\n    font-weight: 400;\n}\n\n/* Assessment Details Card */\n.assessmentDetailsCard {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    border-radius: 24px !important;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;\n    padding: 0 !important;\n    overflow: hidden;\n    animation: fadeInUp 0.8s ease-out 0.2s both;\n    transition: all 0.3s ease;\n}\n\n.assessmentDetailsCard:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.2) !important;\n}\n\n.assessmentDetailsCard .ant-card-body {\n    padding: 32px !important;\n}\n\n.assessmentDetailItem {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    padding: 20px 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    transition: all 0.3s ease;\n}\n\n.assessmentDetailItem:last-child {\n    border-bottom: none;\n}\n\n.assessmentDetailItem:hover {\n    padding-left: 10px;\n}\n\n.detailIconWrapper {\n    width: 56px;\n    height: 56px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n    flex-shrink: 0;\n}\n\n.detailIconWrapper.timeIcon {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    box-shadow: 0 4px 15px rgba(245, 87, 108, 0.4);\n}\n\n.detailIconWrapper.questionIcon {\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);\n}\n\n.detailIcon {\n    font-size: 28px !important;\n    color: #ffffff !important;\n}\n\n.detailContent {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n}\n\n.detailLabel {\n    font-size: 13px;\n    color: #6b7280;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.detailValue {\n    font-size: 20px;\n    color: #1f2937;\n    font-weight: 600;\n}\n\n.assessmentNote {\n    margin-top: 20px;\n    padding: 16px 20px;\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n    border-radius: 12px;\n    border-left: 4px solid #667eea;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.noteIcon {\n    color: #667eea !important;\n    font-size: 20px !important;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.assessmentNote p {\n    margin: 0;\n    color: #4b5563;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n/* Right Section - Visual & Action */\n.assessmentActionSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 40px;\n    position: relative;\n    animation: fadeInUp 0.8s ease-out 0.4s both;\n}\n\n.assessmentVisualWrapper {\n    position: relative;\n    width: 100%;\n    height: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.gradientOrb {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(60px);\n    opacity: 0.6;\n    animation: float 6s ease-in-out infinite;\n}\n\n.orb1 {\n    width: 200px;\n    height: 200px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    top: 10%;\n    left: 10%;\n    animation-delay: 0s;\n}\n\n.orb2 {\n    width: 150px;\n    height: 150px;\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    bottom: 20%;\n    right: 15%;\n    animation-delay: 2s;\n}\n\n.orb3 {\n    width: 180px;\n    height: 180px;\n    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    animation-delay: 4s;\n}\n\n@keyframes float {\n    0%, 100% { transform: translate(0, 0) scale(1); }\n    33% { transform: translate(20px, -20px) scale(1.1); }\n    66% { transform: translate(-20px, 20px) scale(0.9); }\n}\n\n.assessmentImageContainer {\n    position: relative;\n    z-index: 2;\n    animation: pulse 3s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { transform: scale(1); }\n    50% { transform: scale(1.05); }\n}\n\n.assessmentImage {\n    width: 320px;\n    height: 320px;\n    object-fit: contain;\n    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2));\n    transition: all 0.3s ease;\n}\n\n.assessmentImage:hover {\n    transform: scale(1.05) rotate(2deg);\n    filter: drop-shadow(0 25px 50px rgba(0, 0, 0, 0.3));\n}\n\n/* Start Test Button */\n.startTestButton {\n    width: 100%;\n    max-width: 320px;\n    height: 60px !important;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    border-radius: 16px !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    color: #ffffff !important;\n    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4) !important;\n    transition: all 0.3s ease !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 10px !important;\n    position: relative;\n    overflow: hidden;\n}\n\n.startTestButton::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.5s ease;\n}\n\n.startTestButton:hover::before {\n    left: 100%;\n}\n\n.startTestButton:hover {\n    transform: translateY(-3px) scale(1.02) !important;\n    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.5) !important;\n}\n\n.startTestButton:active {\n    transform: translateY(-1px) scale(0.98) !important;\n}\n\n.startTestButton:disabled {\n    opacity: 0.7 !important;\n    cursor: not-allowed !important;\n    transform: none !important;\n}\n\n.startTestButton .anticon {\n    font-size: 22px !important;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .assessmentContainer {\n        grid-template-columns: 1fr;\n        gap: 30px;\n    }\n\n    .assessmentActionSection {\n        order: -1;\n    }\n\n    .assessmentVisualWrapper {\n        height: 300px;\n    }\n\n    .assessmentImage {\n        width: 250px;\n        height: 250px;\n    }\n}\n\n@media (max-width: 768px) {\n    .assessmentMainDiv {\n        padding: 30px 20px;\n    }\n\n    .assessmentTitle {\n        font-size: 32px;\n    }\n\n    .assessmentSubtitle {\n        font-size: 14px;\n    }\n\n    .assessmentDetailsCard .ant-card-body {\n        padding: 24px !important;\n    }\n\n    .assessmentDetailItem {\n        padding: 16px 0;\n    }\n\n    .detailIconWrapper {\n        width: 48px;\n        height: 48px;\n    }\n\n    .detailIcon {\n        font-size: 24px !important;\n    }\n\n    .detailValue {\n        font-size: 18px;\n    }\n\n    .assessmentVisualWrapper {\n        height: 250px;\n    }\n\n    .assessmentImage {\n        width: 200px;\n        height: 200px;\n    }\n\n    .startTestButton {\n        max-width: 100%;\n        height: 56px !important;\n        font-size: 16px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .assessmentMainDiv {\n        padding: 20px 16px;\n    }\n\n    .assessmentBreadcrumb {\n        font-size: 12px;\n        flex-wrap: wrap;\n    }\n\n    .assessmentTitle {\n        font-size: 28px;\n    }\n\n    .assessmentIconWrapper {\n        width: 60px;\n        height: 60px;\n    }\n\n    .assessmentIcon {\n        font-size: 30px !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
